import { SurveyRecordStates } from '../../generated/graphql';
import { FilterProps } from '../../types/types';
import { enumToOptions } from '../../utils/filters';
import SelectEnumFilter from '../SelectEnumFilter/SelectEnumFilter';

export default function SurveyRecordStateFilter(props: FilterProps) {
    const { value, onChange } = props
    const options = enumToOptions(SurveyRecordStates)
    return (
        <SelectEnumFilter
            value={value}
            onChange={onChange}
            label="Estado"
            field="state"
            multiple
            options={options}
        />
    )
}
